import Gateway from './gateway';

function Help() {
    'use strict';
    this.$wrapper = $('#help');
    this.$trigger = this.$wrapper.find('[data-help-trigger]');
    this.$content = this.$wrapper.find('.help__content');
    this.$helpForm = this.$content.find('form');
    this.$uiLock = this.$content.find('.help__ui-lock');
    this.gateway = new Gateway({url: this.$helpForm.attr('action'), dataType: 'json'});
}

Help.prototype.init = function () {
    'use strict';
    this.$trigger.on('click', this.toggleHelpBoxVisibility.bind(this));
    this.$content.find('button[type="submit"]').on('click', this.handleFormSubmit.bind(this));
    this.$content.find('form').on('submit', this.handleFormSubmit.bind(this));
};

Help.prototype.toggleHelpBoxVisibility = function (e) {
    'use strict';
    e.preventDefault();
    const visible = this.$content.data('visible');

    if (visible) {
        const width = this.$content.width() * -1;
        this.$wrapper.animate({right: width + 'px'});
        this.$content.data('visible', false);
    } else {
        this.$wrapper.animate({right: '0'});
        this.$content.data('visible', true);
    }
};

Help.prototype.handleFormSubmit = function (e) {
    'use strict';
    e.preventDefault();

    this.$uiLock.fadeIn();
    this.gateway.request(
        this.$helpForm.serializeArray(),
        this.handleResponse.bind(this),
        this.$helpForm.attr('method'),
        this.handleError.bind(this)
    );
};

Help.prototype.handleResponse = function (response) {
    'use strict';
    if (response['success']) {
        const showSuccess = function () {
            this.$uiLock.fadeOut();
            this.$content.find('[data-help-success]').fadeIn();
        };
        this.$content.find('.help__form').fadeOut('fast', showSuccess.bind(this));
    }
};

Help.prototype.handleError = function (eventData) {
    'use strict';
    const response = JSON.parse(eventData.responseText);

    if (eventData.status === 400) {
        this.$uiLock.fadeOut();
        this.$helpForm.find('input, textarea').each(function (index, element) {
            $(element).removeClass('help__input-error');
        });

        for (var i = 0; i < response['errorFields'].length; i++) {
            this.$helpForm.find('[name="' + response['errorFields'][i] + '"]').addClass('help__input-error');
        }
    }
};

export default Help;